<div class="wrapper">
    <form [formGroup]="formGroup">
        <mat-form-field appearance="outline">
            <mat-label>Field</mat-label>
            <input formControlName="field" matInput required placeholder="Field name" [matAutocomplete]="columnAuto"
                   (blur)="selectFieldFromName()">
            <mat-autocomplete #columnAuto="matAutocomplete" [displayWith]="columnDisplay">
                <mat-option *ngFor="let column of columnsToSearch | async" [value]="column">
                    {{column.title}}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label>Operation</mat-label>
            <input formControlName="operation" matInput required placeholder="<, <=, >, >=, =..."
                   [matAutocomplete]="operationAuto">
            <mat-autocomplete #operationAuto="matAutocomplete">
                <mat-option *ngFor="let operation of searchOperations | async" [value]="operation">
                    {{operation}}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
        <ng-container *ngIf="isManaOrColorColumn(formGroup.get('field').value); else raw">
            <div class="mana-symbol-wrapper">
                <mat-select [(value)]="costSymbol" *ngIf="formGroup.get('field').value.dataType === 'mana'">
                    <mat-select-trigger>
                        <img *ngIf="costSymbol !== ''"
                             class="mana-symbol"
                             alt="{{(cardSymbologyUtils.getSymbols([costSymbol]) | async)[0].english}}"
                             title="{{(cardSymbologyUtils.getSymbols([costSymbol]) | async)[0].english}}"
                             src="{{(cardSymbologyUtils.getSymbols([costSymbol]) | async)[0].svgUri}}"
                        />
                    </mat-select-trigger>
                    <mat-option value="">None</mat-option>
                    <mat-option class="mana-select" [value]="manaSymbol.symbol" *ngFor="let manaSymbol of cardSymbologyUtils.getSymbols(['X', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16']) | async">
                        <img class="mana-symbol"
                             alt="{{manaSymbol.english}}"
                             title="{{manaSymbol.english}}"
                             src="{{manaSymbol.svgUri}}"
                             />
                    </mat-option>
                </mat-select>
                <img *ngFor="let manaSymbol of cardSymbologyUtils.getSymbols(['W','U','B','R','G','C']) | async" class="mana-symbol"
                     [ngClass]="{active: inSelectedColors(manaSymbol.symbol), inactive: !inSelectedColors(manaSymbol.symbol)}"
                     matRipple
                     (click)="toggleSelectedSymbol(manaSymbol.symbol)"
                     alt="{{manaSymbol.english}}"
                     title="{{manaSymbol.english}}"
                     src="{{manaSymbol.svgUri}}"/>
            </div>
        </ng-container>
        <ng-template #raw>
            <ng-container>
                <mat-form-field appearance="outline">
                    <mat-label>Value</mat-label>
                    <input formControlName="value" matInput placeholder="Value...">
                </mat-form-field>
            </ng-container>
        </ng-template>
    </form>
    <span class="spacer"></span>
    <button mat-icon-button class="remove-button" (click)="removeMe()" [disabled]="!editable">
        <mat-icon>delete_outline</mat-icon>
    </button>
</div>
